// eslint-disable-next-line import/no-anonymous-default-export
export default (number: number) => {
  let value;
  value = isNaN(number) ? 0 : number;

  return Number(value).toFixed(2)
}

